(function(){
    'use strict';

    angular
    .module('appback')
    .controller('ProductosController', ProductosController)
 
    ProductosController.$inject = ['ProductosService',"$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function ProductosController(ProductosService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.productos = [];
        vm.folletos = [];
        vm.diluyentes = [];
        vm.buscador = "";
        vm.buscadorCmb = "";
        console.log("prod");

        vm.getProductos = function(){
            ProductosService.getProductos(function(data){
            	console.log(data);
              vm.productos = data.productos;
            	vm.folletos = data.folletos;
              vm.diluyentes = data.diluyentes;
              vm.etiquetas = data.etiquetas;
            });
        }


    		vm.myFilterCmb = function (item) { 
            	item.nombre = item.nombre.toLowerCase();
    		    return (item.cantidad_cmb>0 || item.nombre.indexOf(vm.buscadorCmb) !== -1); 
    		};
        vm.getProductos();


        vm.productoscadModal = "";
        vm.seleccionar = function(){
            vm.productoscadModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  templateUrl: 'productoscad.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.productos = vm.productos;

                    /*$scope.myFilter = function (item) { 
                        item.nombre = item.nombre.toLowerCase();
                        return (item.cantidad>0 || item.nombre.indexOf($scope.buscador) !== -1); 
                    };*/

                    $scope.okForm = function(){
                        vm.productoscadModal.close();
                    }
                    $scope.koForm = function(){
                        vm.productoscadModal.close();
                    }
                  }
            });
        }

        vm.diluyentesModal = "";
        vm.seleccionarDiluyentes = function(){
            vm.diluyentesModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  templateUrl: 'productoscad.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.productos = vm.diluyentes;

                    /*$scope.myFilter = function (item) { 
                        item.nombre = item.nombre.toLowerCase();
                        return (item.cantidad>0 || item.nombre.indexOf($scope.buscador) !== -1); 
                    };*/

                    $scope.okForm = function(){
                        vm.diluyentesModal.close();
                    }
                    $scope.koForm = function(){
                        vm.diluyentesModal.close();
                    }
                  }
            });
        }

        vm.productosfollModal = "";
        vm.seleccionarFolletos = function(){
          vm.productosfollModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                templateUrl: 'folletos.html',
                size: 'lg',
                controller: function($scope) {
                  $scope.productos = vm.folletos;

                  $scope.okForm = function(){
                      vm.productosfollModal.close();
                  }
                  $scope.koForm = function(){
                      vm.productosfollModal.close();
                  }
                }
          });
        }

        vm.productosEtiquetasModal = "";
        vm.seleccionarEtiquetas = function(){
          vm.productosEtiquetasModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                templateUrl: 'etiquetas.html',
                size: 'lg',
                controller: function($scope) {
                  $scope.productos = vm.etiquetas;

                  $scope.okForm = function(){
                      vm.productosEtiquetasModal.close();
                  }
                  $scope.koForm = function(){
                      vm.productosEtiquetasModal.close();
                  }
                }
          });
        }

        vm.productoscadModalCmb = "";
        vm.seleccionarCmb = function(){
            vm.productoscadModalCmb = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  //windowClass: 'modal-danger',
                  templateUrl: 'productoscadcmb.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.productos = vm.productos;

                    /*$scope.myFilter = function (item) { 
                        item.nombre = item.nombre.toLowerCase();
                        return (item.cantidad>0 || item.nombre.indexOf($scope.buscador) !== -1); 
                    };*/

                    $scope.okForm = function(){
                        vm.productoscadModalCmb.close();
                    }
                    $scope.koForm = function(){
                        vm.productoscadModalCmb.close();
                    }
                  }
            });
        }
    } 
  
})();